<template>
    <div>
        <div class="head_top">
            <div class="header-main">
                <div class="logo">
                    <div class="logo_img">
                        <img src="https://resource.rcclchina.com.cn/logo/PC/logoHeaderBlue.png" onclick="javascript:window.open('/')">
                    </div>
                    <!-- <img id="cfty" src="https://resource.rcclchina.com.cn/nav/0722homeGIF.gif" style="height:100%;" onclick="window.open('https://www.rcclchina.com.cn/spectrum-of-the-seas/promotion')"> -->
                </div>
                <!-- 步骤条 -->
                <div class="step-warp">
                    <!-- 步骤一 -->
                    <!-- <div class="step-prev-line"><div></div></div> -->
                    <div class="step-finish"></div>
                    <!-- <div class="step step1">1</div> -->
                    <div class="step-next-line "><div></div></div>
                    <div class="step-text">选择游轮舱房</div>

                    <!-- 步骤二 -->
                    <div class="step-prev-line "><div></div></div>
                    <div class="step-finish finish1"></div>
                    <!-- <div class="step step1">2</div> -->
                    <div class="step-next-line "><div></div></div>
                    <div class="step-text" style="left: 104px">填写乘客信息</div>

                    <!-- 步骤三 -->
                    <div class="step-prev-line"><div></div></div>
                    <!-- <div class="step-finish finish1"></div> -->
                    <div class="step">3</div>
                    <div class="step-text" style="width: 70px;left: 256px;">确认支付</div>
                </div>
            </div>
        </div>
        <div class="order_content">
            <div class="content-tips">
              <div class="bg"></div>
              <div class="inner">
                <img class="logo" :src="`${logoImgUrl}/logoAnchorWhite.png`"/>
                <div class="content" v-if="showCountDown">您已下单成功，由于客房紧张，该订单将保留到<span>{{finalPaymentTime}}</span></div>
              </div>
            </div>

            <div class="warp1200">
<!--                <div class="msg_con">-->
<!--                    <img src="https://resource.rcclchina.com.cn/tui2/order/icon-order-msg.png">-->
<!--                    <span>您已下单成功，由于客房紧张，该订单将保留到 <span class="red">{{finalPaymentTime}}</span></span>-->
<!--                </div>-->
                <div class="line_con">
                    <div class="line_info_con">
                        <div class="ship_way">
                            {{cruise.cruiseRoute}}
                        </div>
                        <div class="ship_time">
                            <span>{{cruise.sailDays}}天{{(cruise.sailDays?cruise.sailDays-1: 0)}}晚</span>
                            <span class="ship_text">{{cruise.shipName}}</span>
                        </div>
                        <div class="ship_time">
                            <span class="line_label"></span>
                            <span>{{paymentBookings.sailDateBegin}} - {{paymentBookings.sailDateEnd}}</span>
                        </div>
                    </div>
                    <div class="user_info">
                        <div class="ship_way">
                            联系人信息
                        </div>
                        <div class="ship_time">
                            <span class="line_label">姓<span style="margin-left: 16px;">名：</span></span>
                            <span class="contactName">{{contactName}}</span>
                        </div>
                        <div class="ship_time">
                            <span class="line_label">手机号：</span>
                            <span class="contactTelephone">{{contact.telephone}}</span>
                        </div>
                        <div class="ship_time">
                            <span class="line_label" style="letter-spacing: 2px;">Email：</span>
                            <span class="contactEmail">{{contact.email}}</span>
                        </div>
                    </div>
                </div>
                <!--连通房-->
                <div v-for="(connectBooking, i) in connectBookings" :key="('connectBookingAll_'+i)">
                    <div class="connect_order" v-for="(booking, j) in connectBooking.bookings" :key="('connectBooking_'+j)">
                        <div class="order_con cabinItem active">
                            <div class="order_info_con">
                                <span>船票预订号：</span>
                                <a @click="goToDetail(booking.encBookingId)">
                                    <span class="info_text">{{booking.bookingId}}</span>
                                </a>
                            </div>
                            <div class="room_con payment_con">
                                <div class="room_item">
                                    <div class="room_img">
                                        <a @click="goToDetail(booking.encBookingId)">
                                            <img :src="getStateroomImage(booking)">
                                        </a>
                                    </div>
                                    <div class="room_info_con">
                                        <div class="room_title">
                                          <a @click="goToDetail(booking.encBookingId)">{{getStateroomName(booking)}}</a>
                                          <NrpTag
                                              :direction="'right'"
                                              :isNrp="booking.isnrp"
                                              :index="('bookingNrpTag_'+booking.bookingId)"
                                              :showRow="booking.isRow"
                                              class="alter_ticket"
                                          />
                                          <img v-if="booking.groupType=='QIAOHU'" @click="isShowQiaohuPopup=true" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png" class="qiaohu_tag">
                                          <img v-else-if="booking.groupType=='STARRYSKY'" @click="isShowStarrySkyPopup=true" src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png" class="starry_sky_tag">
                                          <img v-else-if="booking.groupType=='CUSTOM' || booking.groupType=='PCPGIFT'"
                                               @click="showCustomThemePopup(booking.personalizedStateroomInfo)"
                                               :src="booking.personalizedStateroomInfo?.roomIconImage" class="starry_sky_tag">
                                          <img class="c_img" src="https://resource.rcclchina.com.cn/cruiseDetail/pc/custom_info.png" @click="isShowConnectRoomPopup=true">
                                        </div>

                                        <div class="room_text">
                                          <div class="title">入住信息</div>
                                          <div class="content">
                                            <span>人数：{{getGuests(booking).length}}人</span>
                                            <span>舱房：{{getStateroom(booking).areaInfo}}</span>
                                            <span>阳台：{{getBalconyArea(booking)}}</span>
                                            <span>房间号：{{booking.stateroomNumber == 'GTY' ? '随机房间号': booking.stateroomNumber}}</span>
                                          </div>
                                        </div>

                                        <div class="room_text">
                                          <div class="title">乘客信息</div>
                                          <div class="content is-guests">
                                            姓名：{{booking.guestsNameStr}}
                                            <!--姓名：<span v-for="(guest,idx) in booking.bookingGuests" :key="guest.id">{{guest.chineseLastName + guest.chineseFirstName}}<span v-if="(idx+1) < booking.bookingGuests.length">、</span></span>-->
                                          </div>
                                        </div>
                                        <template v-if="getUnFilledGuest(booking)">
                                          <el-popover
                                              placement="top-start"
                                              title=""
                                              width="420"
                                              trigger="hover">
                                            <div>暂未完成全部乘客信息填写，建议开航<span class="fc-red">45</span>天前至“我的订单”补全，开航前<span class="fc-red">7</span>天及以内不可再进行修改</div>
                                            <div class="room_fill_guest" slot="reference">
                                              <img :src="`${imgUrl}/icons/icon-warning-triangle.png`"/>
                                              <span>部分乘客信息待补充</span>
                                            </div>
                                          </el-popover>
                                        </template>

                                        <div class="room_pic">
                                          <div class="roomsCon-roomPrice">
                                            <span v-if="getBookingPay(booking).amount==booking.amount">总计：</span>
                                            <span v-else>还需支付</span>
                                            <span class="red">¥&nbsp;</span>
                                            <em>{{Math.round(parseFloat(getBookingPay(booking).amount))}}</em>
                                          </div>
                                          <div class="roomCon_chk" v-if="getBookingPay(booking).isDownPayCruise && getBookingPay(booking).downPayAmount > 0">
                                            <RcclCheckBox
                                                :customItem="booking.bookingId"
                                                v-on:onChanged="setBookingDownpay"
                                                class="chk_btn"
                                            />

                                            <div class="chk_text">
                                              支付订金&nbsp;
                                              <img class="det_icon downpay_icon" @click="showDepositPopup(booking)" src=" https://resource.rcclchina.com.cn/tui2/info/webhao.png">
                                              <!--                                                &nbsp;订金费用 ¥&nbsp;<span>{{getBookingPay(booking).downPayAmount}}</span>-->
                                            </div>

                                            <BookingPriceTip />
                                          </div>

                                          

                                        </div>

<!--                                        <div class="room_jifen" v-if="getBookingIntegral(booking).length > 0" >-->
<!--                                            下船后预计送<span>{{getBookingIntegral(booking)}}</span>积分-->
<!--                                            <IntegralTag :index="booking.bookingId"/>-->
<!--                                            <br/>-->
<!--                                            可至积分商城兑换价值约<span>{{getBookingIntegralValue(booking)}}</span>元电话卡-->
<!--                                        </div>-->


                                    </div>
                                </div>
                                <PcpGiftView :giftInfo="booking.personalizedStateroomInfo"
                                           :shipCode="booking.shipCode"
                                           :sailDate="booking.sailDate"
                                           :guestNumber="getGuests(booking).length"
                                           @open="showCustomThemePopup"
                                           is-on-page-popup
                                           pageName="Pay"></PcpGiftView>
                                <div class="common-clr"></div>
                            </div>
                        </div>
                        <div v-if="j==1" class="c_room_bg">
                          <img src="https://resource.rcclchina.com.cn/cruiseDetail/pc/connect_big_bg.png" alt="">
                        </div>
                    </div>
                </div>
                <!--普通房-->
                <div class="" v-for="(booking, j) in normalBookings" :key="('normalBooking_'+j)">
                    <div class="order_con cabinItem active">
                        <div class="order_info_con">
                            <span>船票预订号：</span>
                            <a @click="goToDetail(booking.encBookingId)">
                                <span class="info_text">{{booking.bookingId}}</span>
                            </a>

                        </div>
                        <div class="room_con payment_con">
                            <div class="room_item">
                                <div class="room_img">
                                    <a @click="goToDetail(booking.encBookingId)">
                                        <img :src="getStateroomImage(booking)">
                                    </a>
                                </div>
                                <div class="room_info_con">
                                    <div class="room_title isTitle">
                                        <a @click="goToDetail(booking.encBookingId)">{{getStateroomName(booking)}}</a>
                                        <NrpTag
                                            :direction="'right'"
                                            :isNrp="booking.isnrp"
                                            :index="('bookingNrpTag_'+booking.bookingId)"
                                            class="alter_ticket"
                                            :showRow="booking.isRow"
                                        />
                                        <img v-if="booking.groupType=='QIAOHU'" @click="isShowQiaohuPopup=true" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png" class="qiaohu_tag">
                                        <img v-else-if="booking.groupType=='STARRYSKY'" @click="isShowStarrySkyPopup=true" src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png" class="starry_sky_tag">
                                        <img v-else-if="booking.groupType=='CUSTOM' || booking.groupType=='PCPGIFT'"
                                             @click="showCustomThemePopup(booking.personalizedStateroomInfo)"
                                             :src="booking.personalizedStateroomInfo?.roomIconImage" class="starry_sky_tag">
                                    </div>
                                    <div class="room_text">
                                        <div class="title">入住信息</div>
                                        <div class="content">
                                          <span>人数：{{getGuests(booking).length}}人</span>
                                          <span>舱房：{{getStateroom(booking).areaInfo}}</span>
                                          <span>阳台：{{getBalconyArea(booking)}}</span>
                                          <span>房间号：{{booking.stateroomNumber == 'GTY' ? '随机房间号': booking.stateroomNumber}}</span>
                                        </div>
                                    </div>
                                    <div class="room_text">
                                      <div class="title">乘客信息</div>
                                      <div class="content is-guests">
                                        姓名：{{booking.guestsNameStr}}
                                        <!--姓名：<span v-for="(guest,idx) in booking.bookingGuests" :key="guest.id">{{guest.chineseLastName + guest.chineseFirstName}}<span v-if="(idx+1) < booking.bookingGuests.length">、</span></span>-->
                                      </div>
                                    </div>
                                    <template v-if="getUnFilledGuest(booking)">
                                      <el-popover
                                          placement="top-start"
                                          title=""
                                          width="420"
                                          trigger="hover">
                                        <div>暂未完成全部乘客信息填写，建议开航<span class="fc-red">45</span>天前至“我的订单”补全，开航前<span class="fc-red">7</span>天及以内不可再进行修改</div>
                                          <div class="room_fill_guest" slot="reference">
                                            <img :src="`${imgUrl}/icons/icon-warning-triangle.png`"/>
                                            <span>部分乘客信息待补充</span>
                                          </div>
                                      </el-popover>
                                    </template>

                                    <div class="room_pic">
                                        <div class="roomsCon-roomPrice">
                                            <span v-if="getBookingPay(booking).amount==booking.amount">总计：</span>
                                            <span v-else>还需支付</span>
                                            <span class="red">¥&nbsp;</span>
                                            <em>{{Math.round(parseFloat(getBookingPay(booking).amount))}}</em>
                                        </div>
                                        <div class="roomCon_chk" v-if="getBookingPay(booking).isDownPayCruise && getBookingPay(booking).downPayAmount > 0">
                                            <RcclCheckBox
                                                :customItem="booking.bookingId"
                                                v-on:onChanged="setBookingDownpay"
                                                class="chk_btn"
                                            />
                                            <div class="chk_text">
                                                支付订金&nbsp;
                                                <img class="det_icon downpay_icon" @click="showDepositPopup(booking)" src=" https://resource.rcclchina.com.cn/tui2/info/webhao.png">
<!--                                                &nbsp;订金费用 ¥&nbsp;<span>{{getBookingPay(booking).downPayAmount}}</span>-->
                                            </div>

                                            <BookingPriceTip />
                                        </div>

                                        

                                    </div>
<!--                                    <div class="room_jifen" v-if="getBookingIntegral(booking).length > 0" >-->
<!--                                        下船后预计送<span>{{getBookingIntegral(booking)}}</span>积分-->
<!--                                        <IntegralTag :index="booking.bookingId"/>-->
<!--                                        <br/>-->
<!--                                        可至积分商城兑换价值约<span>{{getBookingIntegralValue(booking)}}</span>元电话卡-->
<!--                                    </div>-->
                                </div>
                            </div>

                            <PcpGiftView :giftInfo="booking.personalizedStateroomInfo"
                                         :shipCode="booking.shipCode"
                                         :sailDate="booking.sailDate"
                                         :guestNumber="getGuests(booking).length"
                                         @open="showCustomThemePopup"
                                         is-on-page-popup
                                         pageName="Pay"></PcpGiftView>
                            <div class="common-clr"></div>
                        </div>
                    </div>

                </div>

                <div class="same_cruise_tips" v-if="noPayBookings.length > 0">同航线还有未付款订单，是否要合并付款？</div>
                <!--未付款-->
                <div class="normal_order" v-for="(booking, j) in noPayBookings" :key="('noPayBooking_'+j)">
                    <div class="order_con cabinItem">
                        <div class="order_info_con">
                            <RcclCheckBox
                                :customItem="booking.bookingId"
                                v-on:onChanged="setBookingSelected"/>
                            <span>船票预订号：</span>
                            <a @click="goToDetail(booking.encBookingId)">
                                <span class="info_text">{{booking.bookingId}}</span>
                            </a>
                        </div>
                        <div class="room_con payment_con">
                            <div class="room_item">
                                <div class="room_img">
                                    <a @click="goToDetail(booking.encBookingId)">
                                        <img :src="getStateroomImage(booking)">
                                    </a>
                                </div>
                                <div class="room_info_con">
                                    <div class="room_title isTitle">
                                      <a @click="goToDetail(booking.encBookingId)">{{getStateroomName(booking)}}</a>
                                      <NrpTag
                                          :direction="'right'"
                                          :isNrp="booking.isnrp"
                                          :index="('bookingNrpTag_'+booking.bookingId)"
                                          class="alter_ticket"
                                          :showRow="booking.isRow"
                                      />
                                      <img v-if="booking.groupType=='QIAOHU'" @click="isShowQiaohuPopup=true" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png" class="qiaohu_tag">
                                      <img v-else-if="booking.groupType=='STARRYSKY'" @click="isShowStarrySkyPopup=true" src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png" class="starry_sky_tag">
                                      <img v-else-if="booking.groupType=='CUSTOM' || booking.groupType=='PCPGIFT'"
                                           @click="showCustomThemePopup(booking.personalizedStateroomInfo)"
                                           :src="booking.personalizedStateroomInfo?.roomIconImage" class="starry_sky_tag">
                                    </div>

                                    <div class="room_text">
                                      <div class="title">入住信息</div>
                                      <div class="content">
                                        <span>人数：{{getGuests(booking).length}}人</span>
                                        <span>舱房：{{getStateroom(booking).areaInfo}}</span>
                                        <span>阳台：{{getBalconyArea(booking)}}</span>
                                        <span>房间号：{{booking.stateroomNumber == 'GTY' ? '随机房间号': booking.stateroomNumber}}</span>
                                      </div>
                                    </div>

                                    <div class="room_text">
                                      <div class="title">乘客信息</div>
                                      <div class="content is-guests">
                                        姓名：{{booking.guestsNameStr}}
                                        <!--姓名：<span v-for="(guest,idx) in booking.bookingGuests" :key="guest.id">{{guest.chineseLastName + guest.chineseFirstName}}<span v-if="(idx+1) < booking.bookingGuests.length">、</span></span>-->
                                      </div>
                                    </div>
                                    <template v-if="getUnFilledGuest(booking)">
                                      <el-popover
                                          placement="top-start"
                                          title=""
                                          width="420"
                                          trigger="hover">
                                        <div>暂未完成全部乘客信息填写，建议开航<span class="fc-red">45</span>天前至“我的订单”补全，开航前<span class="fc-red">7</span>天及以内不可再进行修改</div>
                                        <div class="room_fill_guest" slot="reference">
                                          <img :src="`${imgUrl}/icons/icon-warning-triangle.png`"/>
                                          <span>部分乘客信息待补充</span>
                                        </div>
                                      </el-popover>
                                    </template>
                                    <div class="room_pic">
                                      <div class="roomsCon-roomPrice">
                                        <span>总计：</span>
                                        <span class="red">¥&nbsp;</span>
                                        <em>{{Math.round(parseFloat(getBookingPay(booking).amount))}}</em>
                                      </div>
                                      <div class="roomCon_chk" v-if="getBookingPay(booking).isDownPayCruise && getBookingPay(booking).downPayAmount > 0">
                                        <RcclCheckBox
                                            :customItem="booking.bookingId"
                                            v-on:onChanged="setBookingDownpay"
                                            class="chk_btn"
                                        />
                                        <div class="chk_text">
                                          支付订金&nbsp;
                                          <img class="det_icon downpay_icon" @click="showDepositPopup(booking)" src=" https://resource.rcclchina.com.cn/tui2/info/webhao.png">
                                          <!--                                                &nbsp;订金费用 ¥&nbsp;<span>{{getBookingPay(booking).downPayAmount}}</span>-->
                                        </div>

                                        <BookingPriceTip />
                                      </div>

                                      

                                    </div>

<!--                                    <div class="room_jifen" v-if="getBookingIntegral(booking).length > 0" >-->
<!--                                        下船后预计送<span>{{getBookingIntegral(booking)}}</span>积分-->
<!--                                        <IntegralTag :index="booking.bookingId"/>-->
<!--                                        <br/>-->
<!--                                        可至积分商城兑换价值约<span>{{getBookingIntegralValue(booking)}}</span>元电话卡-->
<!--                                    </div>-->
                                </div>
                            </div>

                            <PcpGiftView :giftInfo="booking.personalizedStateroomInfo"
                                       :shipCode="booking.shipCode"
                                       :sailDate="booking.sailDate"
                                       :guestNumber="getGuests(booking).length"
                                       @open="showCustomThemePopup"
                                       is-on-page-popup
                                       pageName="Pay"></PcpGiftView>
                        </div>
                    </div>

                </div>

                <div class="line_con choose_pay_con" style="margin-bottom: 0">
                    <div class="pay_title">
                      选择支付方式
                    </div>
                    <div class="pay_way_con">
                        <div class="pay_way_item canSelect" :class="{ active: paymentType == 'ALIPAY'}" @click="paymentType='ALIPAY'">
                            <img src=" https://resource.rcclchina.com.cn/tui2/order/alipay.png">
                        </div>
                        <div class="pay_way_item canSelect" :class="{ active: paymentType == 'WECHATQRCODEPAY'}" @click="paymentType='WECHATQRCODEPAY'">
                            <img src=" https://resource.rcclchina.com.cn/tui2/order/wechartpay.png">
                        </div>
                        <div v-if="paymentMethodType!==null && paymentMethodType===1" class="pay_way_item canSelect" :class="{ active: paymentType == 'UNIONPAY'}" @click="paymentType='UNIONPAY'">
                            <img src="https://resource.rcclchina.com.cn/cruiseDetail/unionPay.png">
                            <span style="color: #000;font-weight: 400; font-size: 16px;">银联支付</span>
                        </div>
                        <div v-if="paymentMethodType!==null && paymentMethodType===1" class="pay_way_item" data-type="offline-pay" @click="isShowBankPopup=true">
                            <img class="offlinePayImage" src=" https://resource.rcclchina.com.cn/tui2/order/cardpay.png">
                            <span>详情</span>
                            <span class="offline-pay-tips">(不推荐)</span>
                        </div>
                    </div>
                </div>
                <div class="order_ft_con" :class="{'isDeposit': !isDeposit}" style="margin-bottom: 10px;">
                    <div class="ft_lf">
                        <div v-if="totalIntegral && totalValuation && (totalIntegralStatus == 1 || totalIntegralStatus == 2)" class="integral_lf">
                          <PointGiveaway :point="totalIntegral" :isFinishSelfInfo="isFinishSelfInfo" :bookingIntegralsStatue="totalIntegralStatus"></PointGiveaway>
                        </div>
                        <div class="unpaid_rg">
                            <div class="payment_ord_num" :class="{'is-deposit': isDeposit}">
                                <span class="blue" id="payment-count">{{paymentBookingCount}}</span> 张订单 |
                                <span>应付总计：
                                    <span class="text payment-total-number">
                                        <span style="font-size:17px;font-weight: 400;margin-right: 5px;">¥</span>
                                        <span class="toPay-m-price">{{paymentAmount.toFixed(0)}}</span>
                                    </span>
                                </span>
                            </div>
                            <div v-if="isDeposit" class="payment_deposit">*最晚于开航45天前支付尾款，逾期将取消</div>
                        </div>
                    </div>
                    <div class="ft_rg" :class="{'isDeposit': !isDeposit}" id="goToPayment" @click="submitPayment()">立即支付</div>
                </div>
                <div class="hsbcBanner" v-if="false">
                  <Swiper
                      ref="bannerSwiper"
                      :options="swiperOptions"
                      class="swiper-container swiper-topics topics"
                      @click-slide="onShowPopupsImg"
                  >
                    <SwiperSlide
                        v-for="(item, i) in hsbcBanners"
                        :key="i"
                        class="swiper-slide promoBannerLink external"
                    >
                      <div  style="width: 100%;height: 100%">
                        <img :src="item.image" alt=""/>
                      </div>
                    </SwiperSlide>
                    <div
                        ref="swiper-pagination"
                        class="swiper-pagination"
                        v-if="hsbcBanners.length > 1"
                        slot="pagination"
                    ></div>
                  </Swiper>
                </div>
                <div class="line_con choose_pay_con">
                    <div class="pay_title">发票说明</div>
                    <div class="pay_text">
                        <p>1） 官网预订仅可开具增值税普通发票，无法开具增值税专用发票。发票内容为“生产生活服务·船票款”，不得进行修改。建议发票在航次结束后3个月内申请开具。</p>
                        <p>2） 官方线下渠道使用美金支付的船票款只能开具形式发票。其它船上消费因已属境外消费，需要找船上开具账单。</p>
                        <p>3） 个人付款可开具个人抬头发票，公司转款可开具公司抬头发票（请务必通过公司账户银行转账）。个人付款如需开具公司抬头发票，需提供公司名称、税号等必要的开票信息。</p>
                        <p>4） 如因订单内容变更总金额发生变动、需要重新开发票的，预订人需先退回原发票后方可开具新的发票。</p>
                    </div>
                </div>
            </div>

            <ConnectRoomPopup
                :isShow="isShowConnectRoomPopup"
                v-on:onModalClose="isShowConnectRoomPopup=false"
            />

            <QiaohuPopup
                :isShow="isShowQiaohuPopup"
                :shipCode="shipCode"
                :sailDate="sailDate"
                v-on:onModalClose="isShowQiaohuPopup=false"
            />

            <StarrySkyPopup
                :isShow="isShowStarrySkyPopup"
                :shipCode="shipCode"
                :sailDate="sailDate"
                v-on:onModalClose="isShowStarrySkyPopup=false"
            />

            <CustomThemePopup
              :isShow="isShowCustomThemePopup"
              :themeInfo="customThemeInfo"
              v-on:onModalClose="closeCustomThemePopup"
            />

            <DepositPopup
                :isShow="isShowDepositPopup"
                :isNrp="targetBooking.isnrp"
                v-on:onModalClose="isShowDepositPopup=false"
            />

            <BankPopup
                :isShow="isShowBankPopup"
                :bankTransferInfo="bankTransferInfo"
                v-on:onModalClose="isShowBankPopup=false"
            />

          <PopupsImg v-show="isShowPopupsImg"
                     :imgUrl="popupsImgUrl"
                     @closePopups="onClosePopups"/>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import { numberWithCommas } from '@/utilities/tools'
import nrpConfig from "@/utilities/nrpConfig";
import { Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import PopupsImg from "@/components/Cruise/popupsImg.vue";
import PointGiveaway from "@/components/Booking/PointGiveaway.vue";
import StarrySkyPopup from "@/components/Cruise/CruiseDetail/StarrySkyPopup.vue";
import CustomThemePopup from "@/components/Cruise/CruiseDetail/CustomThemePopup.vue";
import PcpGiftView from "@/components/PCP/PcpGiftView.vue";
const ConnectRoomPopup = () => import('@/components/Cruise/CruiseDetail/ConnectRoomPopup')
const QiaohuPopup = () => import('@/components/Cruise/CruiseDetail/QiaohuPopup')
const DepositPopup = () => import('@/components/Booking/DepositPopup')
// const IntegralTag = () => import('@/components/Booking/IntegralTag')
const BankPopup = () => import('@/components/Booking/BankPopup')
const RcclCheckBox = () => import('@/components/Common/RcclCheckBox')
const NrpTag = () => import("@/components/Booking/NrpTag.vue");
const BookingPriceTip = () => import("@/components/Booking/Pay/BookingPriceTip");
export default {
    name: "Pay",
    components: {
      PcpGiftView,
      CustomThemePopup,
      PointGiveaway,
        PopupsImg,
        Swiper,
        SwiperSlide,
        RcclCheckBox,
        ConnectRoomPopup,
        QiaohuPopup,
        DepositPopup,
        // IntegralTag,
        BankPopup,
        NrpTag,
        StarrySkyPopup,
        BookingPriceTip,
    },
    directives: {
      swiper: directive,
    },
    data() {
        return {
            imgUrl: process.env.VUE_APP_IMG_URL,
            logoImgUrl: process.env.VUE_APP_LOGO_IMG_URL,
            paymentType: "ALIPAY",
            isHideNoPayBooking: false,
            isShowBankPopup: false,
            isShowDepositPopup:false,
            isShowDownpayPopup: false,
            isShowConnectRoomPopup: false,
            isShowQiaohuPopup: false,
            paymentBookings: {},
            targetBooking: {},
            targetContact: {},
            tagetQiaohu: {
                shipCode: '',
                sailDate: ''
            },
            isDeposit: false,
            totalIntegral: null,
            totalValuation: null,
            totalIntegralStatus: 0,
            swiperOptions: {
              pagination: {
                el: ".swiper-pagination",
              },
              loop: false,
              autoplay: {
                delay: 5000,
              },
            },
            hsbcBanners:null,
            popupsImgUrl:'',
            isShowPopupsImg:false,
            isShowStarrySkyPopup:false,
            bookingViewModels:null,
            bookingState:false,  //订单状态
            paymentMethodType: null,
            bankTransferInfo: {
                popupBoxType:1,// 1显示默认弹框 2.显示临近航线弹框（显示ShowFinalPaymentTime字段）
                showFinalPaymentTime:'' 
            },
            isShowCustomThemePopup: false,
            customThemeInfo: null
        }
    },
    beforeMount() {
        this.initPage()
    },
    mounted () {
        // 隐藏头尾
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: false })
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    methods: {
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken == '') {
                this.$router.push({ name: 'Login', query:{
                    returnUrl: location.href
                }})
                return
            }
            const query = this.$router.currentRoute.query
            this.$loading.show()
            const { data } = await api.booking.paymentPage({
                // 改为加密的encOrderId
                encOrderId: query.orderId,
                // 改为加密的encBookingId
                encBookingId: query.bookingId,
                userName: userToken
            })
            this.$loading.hide()

            if (data) {
                this.paymentMethodType = data.paymentMethodType;
                this.bankTransferInfo.popupBoxType = data.popupBoxType;
                this.bankTransferInfo.showFinalPaymentTime = data.showFinalPaymentTime;
            }
            if (data && data.bookingIntegrals && data.bookingIntegrals.length > 0) {
              let totalIntegral = 0;
              let totalValuation = 0;
              data.bookingIntegrals && data.bookingIntegrals.forEach(row => {
                totalIntegral += row.integral;
                totalValuation += row.valuation;
              })
              this.totalIntegral = totalIntegral;
              this.totalValuation = totalValuation.toFixed('0');
              this.getBookingIntegralsStatue(data.bookingIntegrals)
            }

            if (data && data.apiBookings && data.apiBookings.length > 0) {
                this.paymentBookings = this.initBookings(data)
                this.setIsDeposit();
                const contacts = this.paymentBookings.bookingContacts || []
                if (contacts.length > 0) {
                    this.targetContact = contacts[0]
                }
            } else {
                return this.$router.push({
                    name: "BookingListPage"
                })
            }

            if (data && data.bookingViewModels && data.bookingViewModels.length > 0) {
              this.bookingViewModels = data.bookingViewModels
            } else {
              return this.$router.push({
                name: "BookingListPage"
              })
            }
            try {
                if(window && window.gio){
                    const query = this.$route.query;
                    if(query && query.orderId && query.orderId.length > 0){
                        const orderId = query.orderId
                        const bookingsCount = this.bookings.length + this.noPayBookings.filter(r=>r.isSelected).length
                        window.gio("page.set", "OrderGenerationID", orderId)
                        window.gio("page.set", "CruiseLine", this.shipCode + this.sailDate)
                        window.gio('page.set', 'ShipCode', this.shipCode);
                        window.gio('page.set', 'SailDate', this.sailDate);
                        window.gio("track", "order_id_var", orderId);
                        window.gio('track', 'BookingCount', bookingsCount);
                        window.gio('track','SubmitOF', {
                          'shipCode': this.shipCode,
                          'sailDate': this.sailDate
                        });
                    }
                }
            } catch (e) {
                console.error(e)
            }
           await this.getCruiseBanner()
        },
        // 预处理接口返回结果，新增isSelect字段，将booking pay对象放到booking里面
        initBookings (data) {
            if (data.apiBookings && data.apiBookings.length > 0) {
                data.apiBookings.forEach((booking) => {
                    booking.isSelected = true
                    if (data.bookingViewModels) {
                        const bookingPay = data.bookingViewModels.find(r=>r.bookingRecordId == booking.id)
                        booking.bookingPay = bookingPay
                    }
                    booking.guestsNameStr = this.getGuestsNameStr(booking);
                })
            }

            if (data.noPayApiBookings && data.noPayApiBookings.length > 0) {
                data.noPayApiBookings.forEach((booking) => {
                    booking.isSelected = false
                    if (data.bookingViewModels) {
                        const bookingPay = data.bookingViewModels.find(r=>r.bookingRecordId == booking.id)
                        booking.bookingPay = bookingPay
                    }
                  booking.guestsNameStr = this.getGuestsNameStr(booking);
                })
            }
            return data
        },
        getGuestsNameStr(booking) {
          let guestsNameStr = '';
          booking.bookingGuests.forEach((guest)=> {
            if(guest.chineseFirstName !== "TBA" && guest.chineseLastName !== "TBA") {
              let title = (guest.chineseLastName || '')+(guest.chineseFirstName || '')
              if (title == '') {
                title = `${guest.pinYinLastName} ${guest.pinYinFirstName}`
              }
              guestsNameStr += title + '、';
            }
          })
          return guestsNameStr.substr(0,guestsNameStr.length-1);
        },
        goBack () {
            this.$router.go(-1)
        },
        setBookingSelected (value, bookingId) {
            const booking = this.noPayBookings.find(r=>r.bookingId == bookingId)
            if (booking) {
                booking.isSelected = value
            }
        },
        setBookingDownpay(value, bookingId) {
            let booking = this.bookings.find(r=>r.bookingId == bookingId)
            if (!booking) {
                booking = this.noPayBookings.find(r=>r.bookingId == bookingId)
            }
            if (!booking) return

            if (booking.bookingPay && booking.bookingPay.isDownPayCruise) {
                booking.bookingPay.allowDownPayment = !booking.bookingPay.allowDownPayment
            }
            this.setIsDeposit();
        },
        setIsDeposit () {
          let allowDownPaymentNum = 0;
          this.bookings && this.bookings.forEach((row)=> {
            if(row.bookingPay.allowDownPayment) {
              allowDownPaymentNum += 1;
            }
          })
          this.isDeposit = allowDownPaymentNum > 0;
        },
        getStateroom (booking) {
            const stateroom = booking.stateroomPartView || {}
            return stateroom
        },
        getStateroomName (booking) {
            const stateroom = booking.stateroomPartView || {}
            const name = stateroom.cnName
            let code = stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            let guestNumberText = ''
            switch (this.getGuests(booking).length) {
                case 1: guestNumberText = '单人房'; break;
                case 2: guestNumberText = '双人房'; break;
                case 3: guestNumberText = '三人房'; break;
                case 4: guestNumberText = '四人房'; break;
                default: break;
            }
            return `${name}_${code}（${guestNumberText}）`
        },
        // 阳台面积，包含遮挡率
        getBalconyArea (booking) {
            const stateroom = this.getStateroom(booking)
            if (!stateroom.balconyAreaInfo || stateroom.balconyAreaInfo == '' || stateroom.balconyAreaInfo == '无') {
                return '无'
            }
            if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
                return "(" + stateroom.stateroomShelter + "视线遮挡) " + stateroom.balconyAreaInfo
            }
            return stateroom.balconyAreaInfo
        },
        getStateroomImage (booking) {
            const stateroom = booking.stateroomPartView || {}
            if (!stateroom.stateroomImages || stateroom.stateroomImages.length == 0) {
                return ""
            }
            return stateroom.stateroomImages[0]
        },
        getGuests (booking) {
            return booking.bookingGuests || []
        },
        getGuestName (booking) {
            let guestName = []
            const guests = this.getGuests(booking)
            guests.forEach((guest) => {
                let name = guest.chineseLastName + guest.chineseFirstName;
                if (!name || name.length == 0) {
                    name = `${guest.pinYinLastName} ${guest.pinYinFirstName}`;
                }
                guestName.push(name)
            })
            return guestName.join(' | ')
        },
        getBookingPay(booking) {
            return booking.bookingPay
        },
        getBookingIntegral (booking) {
            if (!this.paymentBookings.bookingIntegrals || this.paymentBookings.bookingIntegrals.length == 0) {
                return ""
            }
            const bookingIntegral = this.paymentBookings.bookingIntegrals.find(r=>r.bookingId == booking.bookingId)
            if (!bookingIntegral) {
                return ""
            }
            return numberWithCommas(bookingIntegral.integral)
        },
        getBookingIntegralValue (booking) {
            if (!this.paymentBookings.bookingIntegrals || this.paymentBookings.bookingIntegrals.length == 0) {
                return ""
            }
            const bookingIntegral = this.paymentBookings.bookingIntegrals.find(r=>r.bookingId == booking.bookingId)
            if (!bookingIntegral) {
                return ""
            }
            return bookingIntegral.valuation.toFixed('0')
        },
        showDepositPopup (booking) {
            this.targetBooking = booking
            this.isShowDepositPopup = true
        },
        closeBankPopup () {
            this.isShowBankPopup = false
        },
        showBankPopup () {
            this.isShowBankPopup = true
        },
        showDownpayPopup () {
            this.isShowDownpayPopup = true
        },
        closeDownpayPopup () {
            this.isShowDownpayPopup = false
        },
        showConnectRoomPopup () {
            this.isShowConnectRoomPopup = true
        },
        closeConnectRoomPopup () {
            this.isShowConnectRoomPopup = false
        },
        showQiaohuPopup (shipCode, sailDate) {
            this.tagetQiaohu = {
                shipCode,
                sailDate
            }
            this.isShowQiaohuPopup = true
        },
        closeQiaohuPopup () {
            this.isShowQiaohuPopup = false
        },
        showBookingIntegralTips() {
            this.$alert.show('积分将于下船后约10天发放至本账户，可在积分商城【积分明细】查看。', {
                button: '我知道了'
            })
        },
        // 去支付
        async submitPayment () {
            const bookingPayments = this.getSubmitPaymentBooking()
            if (bookingPayments.length == 0) return
            let paymentType = this.paymentType + ''
            const request = {
                encBookingId: bookingPayments.map(r=>r.encBookingId).join(','),
                paymentType: bookingPayments.map(r=>r.downPayment).join(','),
                payMethod: paymentType
            }
            await this.checkBookingStates(bookingPayments)
            if(!this.bookingState) return
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.payByMethodHP(request)
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
            }
            if (data && data.checkoutShape && data.checkoutShape.length > 0) {
                this.$router.push({
                    name: "PayByMethod",
                    params: {
                        paymentContent: data,
                        paymentType: paymentType,
                        orderId: data.orderId,
                        requestId: data.requestId,
                        bookingIds: data.bookingIds,
                        totalAmount: data.totalAmount
                    }
                })
            }
        },
        // 获取订单状态
        async checkBookingStates(bookingPayments) {
          const stateParam = {
            encBookingRecordId:''
          }
          for (const r of bookingPayments) {
            if (r.encBookingRecordId) {
              stateParam.encBookingRecordId = r.encBookingRecordId;
              this.$loading.show();
              const res = await api.booking.getPayBookingState(stateParam);
              this.$loading.hide()
              if (!res.data.isBookingValid) {
                this.bookingState = false;
                this.$alert.show(res.errMsg);
                return
              }
              this.bookingState = true; // 订单状态
            }
          }
        },
        getSubmitPaymentBooking () {
            let bookingPayments = []
            this.bookings.forEach((booking) => {
                if (booking.bookingPay) {
                    let bookingPayment = {
                        // 这里使用加密字段
                        encBookingId: booking.encBookingId,
                        downPayment: '',
                        // 这里需要使用加密字段encBookingRecordId
                        encBookingRecordId: booking.encBookingRecordId
                    }
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        bookingPayment.downPayment = 'DOWNPAYMENT_'+booking.bookingId
                    } else {
                        bookingPayment.downPayment = 'NULL'
                    }
                    bookingPayments.push(bookingPayment)
                }
            })
            this.noPayBookings.forEach((booking) => {
                if (booking.bookingPay && booking.isSelected) {
                    let bookingPayment = {
                        // 这里使用加密字段
                        encBookingId: booking.encBookingId,
                        downPayment: '',
                        // 这里需要使用加密字段encBookingRecordId
                        encBookingRecordId: booking.encBookingRecordId
                    }
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        bookingPayment.downPayment = 'DOWNPAYMENT_'+booking.bookingId
                    } else {
                        bookingPayment.downPayment = 'NULL'
                    }
                    bookingPayments.push(bookingPayment)
                }
            })
            return bookingPayments
        },
        goToDetail (encBookingId) {
            this.$router.push({
                name: "BookingDetail",
                query: {
                    bookingId: encBookingId,
                }
            })
        },
        getNrpTitle(isNrp) {
          if (this.isFortyEightHoursNrpCruise) {
            return nrpConfig.fortyEightHoursNrp.title;
          } else if (isNrp) {
            return nrpConfig.nrp.title;
          }
          return nrpConfig.rp.title;
        },
        reload() {
          this.initPage();
        },
        getUnFilledGuest (booking) {
          let unFilledGuestNum = 0;
          booking.bookingGuestExts && booking.bookingGuestExts.forEach((row)=> {
            if(row.unFilledGuest) {
              unFilledGuestNum += 1;
            }
          })
          return unFilledGuestNum > 0;
        },
        async getCruiseBanner() {
          const requestData = {
            businessType:2
          }
          const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
          if (success) {
            this.hsbcBanners = data
          } else {
            this.$alert.show(errMsg);
          }
        },
        onShowPopupsImg(idx){
          this.popupsImgUrl = ''
          this.popupsImgUrl = this.hsbcBanners[idx].popupImageUrl
          this.isShowPopupsImg = true
        },
        onClosePopups(){
          this.isShowPopupsImg = false
        },
        showCustomThemePopup(val) {
          this.customThemeInfo = val;
          this.isShowCustomThemePopup = true;
        },
        closeCustomThemePopup() {
          this.isShowCustomThemePopup = false;
        },

        getBookingIntegralsStatue(arr) { 
            let newArr = [];
            
            if (arr && arr.length > 0) {
                arr.forEach(item => {
                    newArr.push(item)
                })
            }

            // console.log(newArr,'newArrnewArr');
            
            if (newArr && newArr.length > 0) {
                const statusList = newArr.map(item => item.status);
                if (statusList.includes(2)) {
                    this.totalIntegralStatus = 2;
                    return
                }
                const isAllOne = statusList.every(status => status === 1);
                if (isAllOne) {
                    this.totalIntegralStatus = 1;
                    return 
                }
            }
            
            this.totalIntegralStatus = 0;
        },

    },
    computed: {
        
        bookings () {
            return this.paymentBookings.apiBookings || []
        },

         // 显示倒计时状态
        showCountDown () { 
            let bool = true
            if(this.bookings.length == 0) return false
            this.bookings.forEach((booking) => {                
                if (this.getBookingPay(booking) && this.getBookingPay(booking).paymentType == 'DIFF') {
                    bool = false
                }else{
                    bool = true
                }
            })
            return bool
        },

        bookingIds () {
            return this.bookings.map(r=>r.bookingId).join(',')
        },
        encBookingIds () { 
            return this.bookings.map(r=>r.encBookingId).join(',')
        },
        finalPaymentTime () {
            if (this.bookings.length == 0) {
                return ""
            }
            const createDate = moment(this.bookings[0].createdDate)
            return createDate.add(1, 'days').format('YYYY-MM-DD HH:mm:ss', true)
        },
        firstBooking () {
            if (this.bookings.length == 0) return {}
            return this.bookings[0]
        },
        cruise () {
            return this.firstBooking.cruisePartRecordView || {}
        },
        shipCode () {
            if (this.bookings.length == 0) {
                return ""
            }
            return this.bookings[0].shipCode
        },
        sailDate () {
            if (this.bookings.length == 0) {
                return ""
            }
            return this.bookings[0].sailDate
        },
        normalBookings () {
            return this.bookings.filter(r=>!r.connectId || r.connectId.length == 0)
        },
        connectBookings () {
            const connectBookings = this.bookings.filter(r=>r.connectId && r.connectId.length > 0)
            let bookings = []
            connectBookings.forEach((booking) => {
                let connectBooking = bookings.find(r=>r.connectId == booking.connectId)
                if (connectBooking) {
                    connectBooking.bookings.push(booking)
                } else {
                    connectBooking = {
                        connectId: booking.connectId,
                        bookings: [booking]
                    }
                    bookings.push(connectBooking)
                }
            })
            return bookings
        },
        noPayBookings () {
            return this.paymentBookings.noPayApiBookings || []
        },
        contact () {
            return this.targetContact
        },
        contactName () {
            if (!this.contact || !this.contact.id) return ""
            let name = (this.contact.chineseLastName || '') + (this.contact.chineseFirstName || '')
            if (!name || name.length == 0) {
                name = `${this.contact.pinYinLastName} ${this.contact.pinYinFirstName}`
            }
            return name
        },
        paymentBookingCount () {
            return this.bookings.length + this.noPayBookings.filter(r=>r.isSelected).length
        },
        paymentAmount () {
            let amount = 0
            this.bookings.forEach((booking) => {
                if (booking.bookingPay) {
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        amount += booking.bookingPay.downPayAmount
                    } else {
                        amount += booking.bookingPay.amount
                    }
                }
            })
            this.noPayBookings.forEach((booking) => {
                if (booking.isSelected && booking.bookingPay) {
                    if (booking.bookingPay.allowDownPayment && booking.bookingPay.isDownPayCruise) {
                        amount += booking.bookingPay.downPayAmount
                    } else {
                        amount += booking.bookingPay.amount
                    }
                }
            })
            return amount
        },
        isFinishSelfInfo(){
          let userInfo = this.$store.state.user.userInfo;
          let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
          return isLocalReward && userInfo.infoIntegrity === 100;
        }
    }

}
</script>


<style lang="less" scoped>
.head_top {
    position: relative;
    height: 74px;
    top: 0px;
    z-index: 11;
    width: 100%;
    .header-main {
        position: relative;
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        .logo {
            margin-top: 9px;
            margin-left: 0;
        }
    }
}
.order_content {
    a {
        cursor: pointer;
    }
    padding-bottom: 20px;
    background-color: #f0f0f0;
    .msg_con {
        text-align: center;
        line-height: 14px;
        padding: 13px 0;
        height: 36px;
        .msg_con img {
            margin-top: -3px;
        }
        .red {
            color: #ff3022;
        }
    }

    .line_con {
        width: 100%;
        background-color: #fff;
        padding: 20px 20px 20px;
        overflow: hidden;
        border-top: 3px solid #e5f4ff;
        margin-bottom: 12px;
        position: relative;
        .line_info_con {
            float: left;
            max-width: 620px;

        }
        .user_info {
            width: 530px;
            height: 127px;
            float: right;
            padding: 0 20px;
            position: relative;
            border-left: 1px solid #d3dadd;
        }
        .ship_way {
            font-size: 22px;
            color: #282b2c;
            font-weight: 600;
        }
        .ship_time {
            font-size: 16px;
            color: #282b2c;
            padding: 5px 0px;
            line-height: 16px;
            font-weight: 400;
            .line_label {
                color: #747d80;
            }
            .more_day {
                color: #006ab9;
                font-size: 14px;
                font-weight: 400;
                margin-left: 5px;
            }
            .order_ico_25 {
                width: 16px;
                height: 16px;
                display: inline-block;
                vertical-align: middle;
                background: url(https://resource.rcclchina.com.cn/tui2/order/icon-edit.png) no-repeat;
                background-position: 0 0;
            }
            .ship_text {
                margin-left: 18px;
            }
        }
    }

    .order_con {
        margin-bottom: 0;
        .order_info_con {
            background-color: #e5f4ff;
            padding: 8px 20px;
            color: #757575;
            overflow: hidden;
            a:focus, a:hover, a:active {
                text-decoration: none;
            }
            .info_text {
                color: #000000;
                font-weight: 400;
            }
        }
        .room_con {
            background-color: #fff;
            padding: 20px 20px 0;
        }
        .payment_con {
            padding-bottom: 1px !important;
            .room_item {
                margin-bottom: 20px;
                position: relative;
                min-height: 270px;
                .room_img {
                    float: left;
                    vertical-align: middle;
                    width: 380px;
                    height: 270px;
                    margin-right: 20px;
                    img {
                        width: 100%;
                    }
                }
                .room_info_con {
                    overflow: hidden;
                    vertical-align: top;
                    .room_title {
                        //height: 34px;
                        line-height: 34px;
                        font-size: 16px;
                        font-weight: 600;
                        color: #282b2c;
                        display: flex;
                        flex-wrap: wrap;
                        overflow: hidden;
                        &.isTitle {
                          line-height: normal;
                        }
                        a {
                            //float: left;
                            //display: inline-block;
                            font-size: 24px;
                            font-weight: 600;
                            color: #282b2c;
                            //width: 50%;
                            &:hover {
                                text-decoration: none;
                            }
                        }
                        .c_img {
                            //float: left;
                            //display: inline-block;
                            margin-top: 5px;
                            margin-left: 8px;
                            vertical-align: -5px;
                            cursor: pointer;
                        }
                        .alter_ticket {
                          //float: left;
                          display: inline-block;
                          height: 30px;
                          line-height: 30px;
                          text-align: center;
                          border-radius: 30px;
                          margin: 2px 10px 0;
                          width: 110px;
                          background-color: #E3F4FE;
                          color: #0A77BA;
                        }
                    }
                    .room_text {
                        color: #747d80;
                        margin-top: 15px;
                        .split_line {
                            margin: 0 5px;
                        }
                        & .title {
                          font-weight: 600;
                          font-size: 18px;
                          color: #333333;
                        }
                        & .content {
                          font-size: 16px;
                          color: #666666;
                          & span {
                            display: inline-block;
                            margin: 3px 30px 0 0;
                          }
                          &.is-guests span {
                            margin-right: 0;
                          }
                        }
                    }
                    .room_pic {
                        font-size: 16px;
                        font-weight: bold;
                        overflow: hidden;
                        margin-top: 30px;
                        .roomsCon-roomPrice {
                            float: left;
                            & > span {
                              color: #666666;
                            }
                            & .red {
                              color: #ff3022;
                            }
                            & > em {
                              font-size: 30px;
                              font-style: normal;
                              color: #ff3022;
                            }
                        }
                        .roomCon_chk {
                          float: left;
                          margin-left: 40px;
                          margin-top: 15px;
                          display: flex;
                          align-items: center;
                          & .chk_btn {
                            float: left;
                            margin-top: -2px;
                            margin-right: 5px;
                          }
                          & .chk_text {
                            overflow: hidden;
                            color: #333333;
                            
                            & > img {
                              margin-bottom: 4px;
                              margin-left: 5px;
                            }
                          }
                        }
                    }
                    .room_fill_guest {
                      display: inline-block;
                      width: 160px;
                      margin-top: 15px;
                      color: #337ab7;
                      & > img {
                        display: inline-block;
                        margin: 0 5px 2px 0;
                      }
                      & > span {
                        display: inline-block;
                      }
                    }
                }
                .room_jifen {
                    font-size: 14px;
                    color: rgb(40, 43, 44);
                    font-weight: 600;
                    position: absolute;
                    left: 250px;
                    span {
                        color: #3388c8;
                    }
                    img {
                        vertical-align: -2px;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .connect_order {
        position: relative;
        border: 1px solid #fbc500;
        margin-bottom: 10px;
        .c_room_bg {
            position: absolute;
            left: -1px;
            bottom: 329px;
            width: 1200px;
          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -5px;
            content: '';
            height: 12px;
            width: 1px;
            background-color: #fbc500;
          }
          &::after {
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -5px;
            content: '';
            height: 12px;
            width: 1px;
            background-color: #fbc500;
          }
        }
    }

    .normal_order {
        margin-bottom: 10px;
    }

    .same_cruise_tips {
        color: #006ab9;
        font-size: 16px;
        font-weight: bold;
        margin: 10px 0 10px 20px;
    }

    .choose_pay_con {
        .pay_title {
            font-size: 22px;
            font-weight: 400;
            color: #282b2c;
            display: flex;
            gap: 40px;
        }
        .pay_way_con {
            overflow: hidden;
            margin-top: 15px;
            .pay_way_item {
                float: left;
                margin-right: 10px;
                width: 232px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                background-color: #ffffff;
                border: solid 1px #d3dadd;
                color: #006ab9;
                cursor: pointer;
                position: relative;
                .offlinePayImage {
                    position: relative;
                    top: -2px;
                }
                .offline-pay-tips {
                    font-size: 12px;
                    color: red;
                    position: absolute;
                    top: 41px;
                    left: 95px;
                    line-height: 12px;
                }
            }
            .pay_way_item.active {
                border: solid 2px #fbc500;

            }
        }
        .pay_text {
            line-height: 20px;
            margin: 5px 0;
            color: #747d80;
        }
    }

    .order_ft_con {
        background-color: #fff;
        height: 52px;
        clear: both;
        .ft_lf {
            float: left;
            border-top: 1px solid #d3dadd;
            width: calc(100% - 216px);
            padding: 0 10px;
            text-align: right;
            .integral_lf {
              float: left;
              font-size: 16px;
              font-weight: bold;
              color: #282b2c;
              text-align: left;
              height: 52px;
              display: flex;
              align-items: center;
              & > span {
                padding: 0 5px;
                color: #348cc8;
              }
            }
            .unpaid_rg {
                float: right;
                display: flex;
                flex-direction: column;
                .payment_ord_num {
                    float: left;
                    line-height: 43px;
                    color: #282b2c;
                    font-weight: 400;
                    font-size: 15px;
                    &.is-deposit {
                      line-height: 23px;
                    }
                    .blue {
                        color: #54a3de;
                    }
                    .text {
                        font-size: 30px;
                        font-weight: 600;
                        color: #ff3022;
                        position: relative;
                        top: 3px;
                    }
                }
                .payment_deposit {
                  color: #337ab7;
                  white-space: nowrap;
                }
            }
        }
        .ft_rg {
            float: left;
            font-size: 18px;
            color: #282b2c;
            height: 52px;
            line-height: 52px;
            background-color: #fbc500;
            padding: 0 72px;
            cursor: pointer;
            font-weight: 600;
        }
    }

    .room_pic .downPay_css {
        display: inline-block;
        .downpay_icon {
            margin: 0px 5px;
        }
    }

    .det_icon {
        cursor: pointer;
    }

    .qiaohu_tag {
        float: left;
        width: 100px;
        cursor: pointer;
        margin-top: 3px;
    }
    .starry_sky_tag {
      float: left;
      width: 100px;
      cursor: pointer;
      margin-top: 3px;
    }

  .content-tips {
    position: relative;
    color: #282b2c;
    text-align: center;
    margin-bottom: 30px;
    height: 124px;
    z-index: 10;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      background: linear-gradient(to right, #855902 50%, #000000 50%);
    }
    & > .bg {
      position: relative;
      text-align: center;
      height: 124px;
      z-index: 2;
      background: url("https://resource.rcclchina.com.cn/orderInfo/order-submit-pay-bg.jpg")
      center top no-repeat;
    }
    & > .inner{
      text-align: left;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -600px;
      width: 1200px;
      height: 124px;
      font-size: 24px;
      color: #FFFFFF;
      z-index: 99;
      & .logo {
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        height: 57px;
        transform: translateY(-50%);
      }
      & div {
        margin-left: 77px;
        padding-top: 37px;
        & span {
          font-weight: bold;
          font-size: 30px;
          padding: 0 5px;
          margin-left: 15px;
          letter-spacing: -1px;
          border-bottom: 1px solid rgba(255,255,255,.6);
        }
      }
    }
  }
}

</style>
<style>
.el-popper[x-placement^=top]{
  margin-bottom: 20px !important;
}
.el-popper[x-placement^=top] .popper__arrow {
  bottom: -16px;
}
.el-popper .popper__arrow {
  border-width: 15px;
}
.el-popper[x-placement^=top] .popper__arrow::after {
  bottom: 2px;
  margin-left: -15px;
}
.el-popper .popper__arrow::after {
  content: " ";
  border-width: 15px;
}

.el-popper[x-placement^=bottom]{
  margin-top: 20px !important;
}
.el-popper[x-placement^=bottom] .popper__arrow {
  top: -16px;
}
.el-popper .popper__arrow {
  border-width: 15px;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 2px;
  margin-left: -15px;
}
.el-popper .popper__arrow::after {
  content: " ";
  border-width: 15px;
}
.privacy-layout {
  position: absolute;
  top: 5px;
  left: 140px;
}
.hsbcBanner{
  width: 100%;
  height: 130px;
  margin: 10px 0;
  &  .swiper-container {
    width: 100%;
    height: 130px;
    border-radius: 5px;
    overflow: hidden;
  }
  & .swiper-slide{
    width: 100%;
    height: 130px;
  }
  & img{
    width: 100%;
    height: 100%;
  }
}
</style>
